import { isInProgress, isPending } from "App/apiMiddleware";
import { getDefaultNodeImage } from "Areas/SharedFeatures/nodeLabel";
import { getActiveDocumentId } from "Areas/Sidebar/Documents/redux/getActiveDocumentId";
import getProjectId from "Areas/Sidebar/Documents/redux/getProjectId";
import { getObjects } from "Areas/Sidebar/Documents/redux/selectors";
import { EMPTY_VALUE } from "Common/componentUtils/constants";
import { OPTION_TYPE } from "Common/dictionaries/optionType";
import filter from "lodash/filter";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import get from "lodash/get";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import join from "lodash/join";
import keys from "lodash/keys";
import map from "lodash/map";
import pick from "lodash/pick";
import pickBy from "lodash/pickBy";
import values from "lodash/values";
import { createSelector } from "reselect";
import { getInnerObjectsSelectedIds } from "../../documentDetails/redux/selectors";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import { buildGetDocumentTableDataScope } from "../utils/buildActionCreatorsScope";
import actionTypes from "./actionTypes";
import reduxStoreExternal from "./reduxStoreExternal";
export { getActiveDocumentId, getProjectId };
export const getColumns = createSelector((state) => getActiveDocumentId(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].sourceDataHeadersKey[${getActiveDocumentId(state)}]`), (activeDocumentId, _) => activeDocumentId ? reduxStoreExternal.sourceDataHeaders[activeDocumentId] : undefined);
export const getRows = createSelector((state) => getActiveDocumentId(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].sourceDataRowsKey[${getActiveDocumentId(state)}]`), (activeDocumentId, _) => activeDocumentId ? reduxStoreExternal.sourceDataRows[activeDocumentId] : undefined);
export const getTableNavigationRows = createSelector((state) => getColumns(state), (state) => getRows(state), (state) => getObjects(state), (columns, rows, documentObjects) => {
    if (!columns || !rows || !documentObjects)
        return undefined;
    const imgColumnIndex = findIndex(columns, ["Type", OPTION_TYPE.IMAGE]);
    const stringColumnIndex = map(keys(pickBy(columns, { Type: OPTION_TYPE.STRING })), Number);
    const result = {};
    forEach(rows, row => {
        const documentObject = row.DocumentObjectId
            ? documentObjects[row.DocumentObjectId]
            : undefined;
        const text = join(filter(row.Values, (val, ind) => val && includes(stringColumnIndex, ind)), "; ");
        result[row.Id] = {
            id: row.Id,
            imgSrc: imgColumnIndex !== -1 && row.Values && row.Values[imgColumnIndex]
                ? row.Values[imgColumnIndex]
                : getDefaultNodeImage(documentObject),
            text: documentObject
                ? `${documentObject.Name}${text ? ` | ${text}` : ""}`
                : text || EMPTY_VALUE
        };
    });
    return result;
});
export const getInitialNodesSource = createSelector((state) => getActiveDocumentId(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].initialNodesSourceKey[${getActiveDocumentId(state)}]`), (activeDocumentId, _) => activeDocumentId ? reduxStoreExternal.initialNodesSource[activeDocumentId] : undefined);
export const getNodesSource = createSelector((state) => getActiveDocumentId(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].nodesSourceKey[${getActiveDocumentId(state)}]`), (activeDocumentId, _) => activeDocumentId ? reduxStoreExternal.nodesSource[activeDocumentId] : undefined);
export const getAvailableDocumentObjectIds = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].availableDocumentObjectIds[${getActiveDocumentId(state)}]`), (availableDocumentObjectIds) => availableDocumentObjectIds);
export const getSelectedDocumentObjectIds = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].selectedDocumentObjectIds[${getActiveDocumentId(state)}]`), (selectedDocumentObjectIds) => selectedDocumentObjectIds);
const emptyNodeSource = [];
export const getSourcesSelected = createSelector((state) => getInnerObjectsSelectedIds(state), (state) => getNodesSource(state), (selectedIds, nodesSource) => {
    if (!selectedIds || isEmpty(selectedIds) || !nodesSource)
        return emptyNodeSource;
    return values(pick(nodesSource, selectedIds));
});
export const getDetailedPanelOpen = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].detailedPanelOpen`), (detailedPanelOpen) => detailedPanelOpen);
export const getCalculatedDetailedPanelOpen = createSelector((state) => getSourcesSelected(state), (state) => getDetailedPanelOpen(state), (selected, detailedPanelOpen) => detailedPanelOpen === undefined ? Boolean(selected === null || selected === void 0 ? void 0 : selected.length) : detailedPanelOpen);
export const getTableFilters = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].tableFilters[${getActiveDocumentId(state)}]`), (tableFilters) => tableFilters);
export const getTableSortOptions = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].tableSortOptions[${getActiveDocumentId(state)}]`), (tableSortOptions) => tableSortOptions);
export const getSaveInProgress = (state) => isInProgress(state, `${actionTypes.SAVE_DOCUMENT_TABLE_DATA}_${getActiveDocumentId(state)}`);
export const getDocumentTableDataInProgress = (state) => {
    const documentId = getActiveDocumentId(state);
    return Boolean(documentId && isInProgress(state, buildGetDocumentTableDataScope(documentId)));
};
export const getInProgress = (state) => isPending(state, `${actionTypes.GET_AVAILABLE_DOCUMENT_OBJECT_IDS}_${getActiveDocumentId(state)}`) ||
    getDocumentTableDataInProgress(state) ||
    getSaveInProgress(state) ||
    isPending(state, `${actionTypes.GET_NODE_SOURCES}_${getActiveDocumentId(state)}`);
